import { apiSlice } from "../../../api/ApiService";

const completeRedemptionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    completeRedemption: builder.mutation({
      query: ({ body, accessToken }) => ({
        url: `/api/v1/Administration/complete-redemption`,
        method: "POST",
        data: body,
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: [{ type: "PatientRedemptionDetails" }],
    }),
  }),
  overrideExisting: false,
});

export const { useCompleteRedemptionMutation } = completeRedemptionApi;
export default completeRedemptionApi;
